import React,{useState, useEffect}  from 'react';
import {Card,Button} from 'react-bootstrap';
import Sides from '../Bars/Jssidebar';

import { Helmet } from "react-helmet";
function Csbreak(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
    <Sides/>
     
      <Helmet>
 
 <title>Learn Free JavaScript Break Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript Break tutorial for beginners,When a Javascript break is encountered inside any loop, control automatically passes to the first statement after the loop" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,Javascript Break,Javascript break for,Javascript break for loop,end for loop Javascript,Javascript exit for loop,javascript break,javascript break foreach,javascript break for loop,javascript break loop,Javascript foreach break" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-break" />
 </Helmet>

 <div className='lg:pl-56'>


    <h1 className="m-4 mh1">Javascript Break</h1>
    <div className="first">
        <a href="/javascript-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">1, Javascript break keyword is used to exit from loop and switch<br/>
2, When a Javascript break encounters inside any loop, control automatically passes to the first statement after the loop.<br/>
3, Break in Javascript break statement is used to terminate a loop immediately.<br/>
</p>
<h2 className="mt-4 mh2">The syntax for Javascript Break:</h2>



    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-10">Break; </span>          
          {"\n"}
          {"\n"}
    
       
        </code>
      </pre>        
    </div>


<h2 className="headings">Q-Write a program loop start from 1 to 10 but Break on 5 in Javascript break Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
          {"\n"}
          {"\n"}
         
  <span className="qwerty-10">&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-3">var </span>
    <span className="qwerty-4">i</span>
  <span className="qwerty">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty">&#60;=</span>
  <span className="qwerty-1">10;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&#123; </span>

  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span> 
        <span className="qwerty">==</span> 
        <span className="qwerty-1">5</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span> 

      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&#125; </span>
  {"\n"}
  {"\n"}

<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
        </code>
      </pre>        
    </div>
    
    
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;1 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;2 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;3 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;4 </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>




<h2 className="headings">Q-Write a program Break on first, even no in Javascript Break for loop Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
          {"\n"}
          {"\n"}
         
  <span className="qwerty-10">&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-3">var </span>
    <span className="qwerty-4">i</span>
  <span className="qwerty">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty">&#60;=</span>
  <span className="qwerty-1">10;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&#123; </span>

  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span> 
        <span className="qwerty">%</span> 
        <span className="qwerty-1">2</span> 
        <span className="qwerty">==</span> 
        <span className="qwerty-1">0</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}

  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&#125; </span>
  {"\n"}
  {"\n"}

<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
    
        </code>
      </pre>        
    </div>
    
    
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;1 </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q-Write a program Break if i==4 in Javascript Break for loop?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
          {"\n"}
          {"\n"}
         
  <span className="qwerty-10">&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-3">var </span>
    <span className="qwerty-4">i</span>
  <span className="qwerty">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty">&#60;=</span>
  <span className="qwerty-1">10;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&#123; </span>

  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span> 
        <span className="qwerty">==</span> 
        <span className="qwerty-1">4</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;break;</span>


  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;document</span>
    <span className="qwerty">.</span>
    <span className="qwerty-2">write</span>
    <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
      <span className="qwerty-3">That is Break </span> 
      <span className="qwerty-1">"</span> 
      <span className="qwerty">+</span> 
      <span className="qwerty-4">i</span> 

    <span className="qwerty-1">);</span>



   
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125;</span>

    {"\n"}


  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;document</span>
    <span className="qwerty">.</span>
    <span className="qwerty-2">write</span>
    <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
      <span className="qwerty-3">Break Complete</span> 
      <span className="qwerty-1">"</span> 
    <span className="qwerty-1">);</span>
    {"\n"}   {"\n"}

 

<span className="qwerty-3">&#60;/</span>
<span className="qwerty">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}       {"\n"}
      </code>
      </pre>        
    </div>
    
    
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-1">That is Break1 </span>          
          {"\n"}
          <span className="qwerty-3">That is Break2 </span>   
          {"\n"}
          <span className="qwerty-1">That is Break3 </span>  
          {"\n"}
          <span className="qwerty-3">Break Complete </span>  
            </code>       {"\n"}       {"\n"}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/javascript-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csbreak;